import { render } from "./SmileyComponent.vue?vue&type=template&id=b6bf3896&scoped=true&ts=true"
import script from "./SmileyComponent.vue?vue&type=script&lang=ts"
export * from "./SmileyComponent.vue?vue&type=script&lang=ts"

import "./SmileyComponent.vue?vue&type=style&index=0&id=b6bf3896&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6bf3896"]])

export default __exports__